import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.root');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/ggeea/service";

@Component({
    selector: 'wiz-page-root',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.root/view.scss */
:host {
  display: block;
  height: 100%;
}`],
})
export class PageRootComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }
    public async ngOnInit() {
        // Immediately replace to avoid leaving "/" in history
        location.replace('/main');
    }
}

export default PageRootComponent;